import { useMutation } from '@tanstack/react-query';

import { Canvases } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getCanvasDetailKey } from '~/swr-hooks/canvases/useCanvas';
import { queryClient } from '~/swr-hooks/queryClient';

export type UsePrivateCanvasesCreateNodesMutationParams = NonNullable<Parameters<typeof Canvases.Nodes.create>[0]> & {
  skipInvalidation?: boolean;
};

export const usePrivateCanvasesCreateNodesMutation = () =>
  useMutation({
    mutationFn: (params: UsePrivateCanvasesCreateNodesMutationParams) =>
      callAirApi(() => Canvases.Nodes.create(params)),
    onError: (error) => {
      reportErrorToBugsnag({ context: 'Failed to batch create canvas nodes', error });
    },
    onSuccess: (_, params) => {
      if (params.skipInvalidation) {
        return;
      }

      queryClient.invalidateQueries({
        queryKey: getCanvasDetailKey({ canvasId: params.canvasId, workspaceId: params.workspaceId }),
      });
    },
  });
